module.exports = "https://cdn.realtymogul.com/static/media/icon_holdperiod.f2824558.svg";